var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box is-centered wrapper-rep-receiver" }, [
    _c("div", { staticClass: "modal", class: { "is-active": _vm.modal } }, [
      _c("div", { staticClass: "modal-background" }),
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c(_vm.component, {
            tag: "Component",
            on: {
              close: function($event) {
                return _vm.onCloseModal()
              }
            }
          })
        ],
        1
      ),
      _c("button", {
        staticClass: "modal-close is-large",
        attrs: { "aria-label": "close" },
        on: { click: _vm.onCloseModal }
      })
    ]),
    _vm._m(0),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        {
          staticClass: "column",
          class: { "is-5": !_vm.inline, "is-4": _vm.inline }
        },
        [
          _c("CustomerSearcherByEmail", {
            ref: "inputEmail",
            attrs: {
              id: "email",
              label: "Email del cliente",
              name: "email",
              value: _vm.email,
              disabled: _vm.isLoading || _vm.disabled,
              required: true
            },
            on: {
              select: function($event) {
                return _vm.openModal("InvoiceList")
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "column",
          class: { "is-5": !_vm.inline, "is-4": _vm.inline }
        },
        [
          _c("AppInputField", {
            attrs: {
              id: "name",
              name: "name",
              label: "Nombre del cliente:",
              value: _vm.name,
              placeholder: "Nombre Apellido",
              required: true,
              disabled: _vm.isLoading || _vm.disabled
            },
            on: { input: _vm.onChangeUser, change: _vm.onChangeUser }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container is-flex" }, [
      _c(
        "h1",
        {
          staticClass:
            "title is-centered is-4 has-text-primary title-rep-receiver"
        },
        [_vm._v("\n      Detalles de Receptor\n    ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }